export default "__VITE_ASSET__d3e658ee__"